import { DAY_MS } from './constants'
import type { CloseMethod, RepeatPolicy, RepeatState } from './types'

export const EMPTY_STATE: RepeatState = Object.freeze({
  showCount: 0,
  closeCount: 0,
  lastShownAt: null,
  lastCloseMethod: null
}) as RepeatState

export function cooldownDays (policy: RepeatPolicy, state: RepeatState): number {
  switch (state.lastCloseMethod) {
    case 'overlay':
      return policy.afterOverlay?.days ?? 0
    case 'cta':
      return policy.afterCta?.days ?? 0
    case 'close': {
      const list = policy.afterClose ?? []
      if (list.length === 0) return 0
      const exact = list.find(e => e.occurrence === state.closeCount)
      if (exact) return exact.days
      const last = list[list.length - 1]
      return state.closeCount > last.occurrence ? last.days : 0
    }
    default:
      // null — показали, но вкладку закрыли раньше модалки: кулдауна нет.
      return 0
  }
}

export function canShow (policy: RepeatPolicy | null, state: RepeatState, now: number): boolean {
  if (policy === null) return true
  if (policy.maxShows !== undefined && state.showCount >= policy.maxShows) return false
  if (state.lastShownAt === null) return true
  return now - state.lastShownAt >= cooldownDays(policy, state) * DAY_MS
}

export function applyShown (state: RepeatState, now: number): RepeatState {
  return { ...state, showCount: state.showCount + 1, lastShownAt: now, lastCloseMethod: null }
}

export function applyClose (state: RepeatState, method: CloseMethod): RepeatState {
  return {
    ...state,
    lastCloseMethod: method,
    closeCount: method === 'close' ? state.closeCount + 1 : state.closeCount
  }
}
